import React from 'react'

function WebDevServicesDetails() {
  return (
    <div>
      <div className="services-details-area default-padding">
        <div className="cotnainer">
          <div className="row">
            <div className="col-lg-10 offset-lg-1">
              <div className="site-heading text-center">
                <h4 className="sub-title">Software Development</h4>
                <h2 className="title">Software Development That Drives Your Business Success</h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="services-details-items">
            <div className="row">
              <div className="col-xl-12 services-single-content">
                <div className="thumb mb-50">
                  <img src="static/img/web/21.jpg" alt="Thumb" />
                </div>
                <p>
                  At Microcode Software, we deliver exceptional software development services customized to your business requirements. As a leading software development company, we provide solutions based on the latest technologies and innovative thinking for high performance, growth, and efficiency. We always manage to deliver the project on time without any quality sacrifice. Whether you want enterprise-grade applications, custom software development, or SaaS products, we are committed to fulfilling your business software requirements and making your software future-ready.
                </p>
                <div className="process-style-one-items mt-50">
                  <div className="choose-us-one-thumb">
                    <div className="content">
                      <div className="left-info">
                        <h2 className="title">
                          Smart Software for Bold Businesses
                        </h2>
                      </div>
                      <div className="process-style-one">
                        <div className="process-style-one-item">
                          <span>01</span>
                          <h4>Planning & Analysis</h4>
                          <p>
                            Clarify objectives for the project, identify requirements, and develop the project plan.
                          </p>
                        </div>
                        <div className="process-style-one-item">
                          <span>02</span>
                          <h4>Design & Development</h4>
                          <p>
                            Establish system architecture, UI/UX and build the software by developing code.
                          </p>
                        </div>
                        <div className="process-style-one-item">
                          <span>03</span>
                          <h4>Testing & Deployment</h4>
                          <p>
                            Test for defects, verify quality, and deploy the product to users.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default WebDevServicesDetails
